<app-alert-modal
  #unlockModal
  [headerLabel]="displayHeader || unlockModalHeader"
  [showCrossBtn]="true"
  [showConfirmationBtn]="false"
  [modalOptions]="{
    class: isLivestreamContext ? 'livestream-desktop-right-modal' : ''
  }"
  (canceled)="onModalCanceled()"
>
  <div
    *ngIf="displayItem && displayItem?.isLocked"
    class="subscription-option-modal locked-system-container-music"
  >
    <div class="d-flex flex-column subscription-option">
      <div class="locked-system">
        <div class="locked-system-btn buttons">
          <app-button
            *ngIf="hasIndividualPrice"
            (click)="onPurchaseIndividual()"
            [btnField]="{
              type: 'button',
              label: getPurchaseTextBtn(),
              class: 'btn btn-primary w-100',
              disabled: isOuterUnlockDisabled
            }"
          ></app-button>

          <div *ngIf="showOrBeforeSubscription" class="my-1 text-center">
            {{ Fields.or }}
          </div>

          <app-button
            *ngIf="hasSubscription"
            (click)="onPurchaseSubscription()"
            [btnField]="{
              type: 'button',
              label: getSubscribeTextBtn(),
              class: 'btn btn-primary w-100',
              disabled: isOuterUnlockDisabled
            }"
          ></app-button>

          <div *ngIf="showOrBeforeNft" class="my-1 text-center">
            {{ Fields.or }}
          </div>

          <app-button
            *ngIf="hasNft"
            (click)="onPurchaseNft()"
            [btnField]="{
              type: 'button',
              label: getNFTTextBtn(),
              class: 'btn btn-primary w-100',
              disabled: isOuterUnlockDisabled
            }"
          ></app-button>

          <div *ngIf="showOrBeforeLoyalty" class="my-1 text-center">
            {{ Fields.or }}
          </div>

          <button
            *ngIf="
              !!displayItem?.lock_through?.individual?.loyalty_points &&
              isWhiteLabelWebsite
            "
            type="button"
            (click)="openUnlockWithPointsModal()"
            class="btn btn-primary medium unlock-with-points-btn w-100"
            [disabled]="isOuterUnlockDisabled"
          >
            <span class="unlock-with-points-btn__label">
              {{ LOCKED_POST_MESSAGES.UNLOCK_POST_LOYALTY_PREFIX }}
            </span>
            <img
              class="unlock-with-points-btn__coin"
              src="assets/images/svg/feature-icons/point-coin.svg"
              width="16"
              height="16"
              [attr.alt]="LOYALTY_POINTS_TEXT.COIN_ALT"
              loading="lazy"
              decoding="async"
            />
            <span class="unlock-with-points-btn__points">
              {{
                displayItem?.lock_through?.individual?.loyalty_points | number
              }}{{ UNLOCK_WITH_POINTS_BTN.AMOUNT_POINTS_SUFFIX }}
            </span>
          </button>

          <div
            *ngIf="showBuyEntireAlbum"
            class="my-1 text-center">
              {{ Fields.or }}
          </div>
          <app-button
            *ngIf="showBuyEntireAlbum"
            (click)="purchaseMasterData()"
            [btnField]="{
              type: 'button',
              label: PURCHASE_MASTER_DATA_TEXT[portfolioType],
              class: 'btn btn-primary w-100'
            }"
          ></app-button>
        </div>

        <div class="purchase-via-subscription-lock">
          <app-unlock-content
            *ngIf="displayItem"
            class="unlock-content merchandise"
            #shopifyUnlocker
            [contentId]="displayItem?.sk"
            [lockDetails]="displayItem"
            [userProfile]="userProfile"
            [userSubscriptionList]="userSubscriptionList"
            [contentType]="contentType"
            [headerType]="headerType"
            [userId]="userId"
            [userName]="userName"
            [portfolioTypeId]="portfolioTypeId"
            [isIndividualPortfolio]="isIndividualPortfolio"
            [isAllowedToRedirect]="isAllowedToRedirect"
            [isLivestreamContext]="isLivestreamContext"
            [isLocked]="!displayItem?.unlocked_through?.is_outer_unlocked"
            (closePreviousModal)="handleUnlockContentClose()"
          ></app-unlock-content>
        </div>
      </div>
    </div>
  </div>
</app-alert-modal>
